import React from 'react';
import LegalDocument from '../components/LegalDocument';
import LegalPageLayout from '../components/LegalPageLayout';
import { TERMS_BETA_NOTICE, TERMS_INTRO, TERMS_PAGE_TITLE, TERMS_SECTIONS } from '../legal/termsContent';

const TermsPage: React.FC = () => (
  <LegalPageLayout title={TERMS_PAGE_TITLE}>
    <div data-testid="terms-page">
      <h1 className="text-3xl md:text-4xl font-bold text-secondary-900 dark:text-white mb-4">
        {TERMS_PAGE_TITLE}
      </h1>
      <p
        data-testid="terms-beta-notice"
        className="mb-6 rounded-lg border border-amber-300/60 bg-amber-50 px-4 py-3 text-sm text-amber-950 dark:border-amber-500/40 dark:bg-amber-950/40 dark:text-amber-100"
      >
        {TERMS_BETA_NOTICE}
      </p>
      <div className="space-y-4 mb-10 text-secondary-700 dark:text-secondary-300 leading-relaxed">
        {TERMS_INTRO.map((paragraph) => (
          <p key={paragraph.slice(0, 48)}>{paragraph}</p>
        ))}
      </div>
      <LegalDocument sections={TERMS_SECTIONS} />
    </div>
  </LegalPageLayout>
);

export default TermsPage;
